import { render, staticRenderFns } from "./SelectPaymentButton.vue?vue&type=template&id=1fb08d3c&"
import script from "./SelectPaymentButton.vue?vue&type=script&lang=js&"
export * from "./SelectPaymentButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports